import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';

import { useUserContext } from 'providers/UserProvider';

import Table from 'components/common/Table';

import { putAwayApi } from 'api';

import {
  getPutAwayListColumns,
  PUT_AWAY_FILTER_OPTIONS,
} from 'constants/putAway';

import paths from 'routes/paths';

const Putaway = () => {
  const navigate = useNavigate();

  const { selectedTenant, selectedWarehouse } = useUserContext();

  const tenant = selectedTenant?.domains?.[0]?.domain;
  const warehouse = selectedWarehouse?.domain;
  const initialFilter = { warehouse: selectedWarehouse?.id };

  const headerActions = (
    <Button
      variant="primary"
      size="sm"
      onClick={() => navigate(paths.putAway.create(tenant, warehouse))}
    >
      Create Putaway
    </Button>
  );

  const exportApi = useCallback(params => {
    return putAwayApi.exportPutaway(params);
  }, []);

  return (
    <Table
      title="Putaway"
      apiService={putAwayApi}
      exportApi={exportApi}
      sortable={true}
      columns={getPutAwayListColumns(tenant, warehouse)}
      filterOptions={PUT_AWAY_FILTER_OPTIONS}
      initialFilter={initialFilter}
      headerActions={headerActions}
    />
  );
};

export default Putaway;
